import { Color, Mesh } from 'three';
import { changeAllMeshsColor } from './changeAllMeshsColor';

export const highlightAllMeshs = (meshList: Mesh[]): void => {
  changeAllMeshsColor(new Color('#FFFFFF'), meshList);
};
